module.exports = __webpack_public_path__ + "img/edit-pencil-blue.bdffd95e.svg";